module.exports = ("1.5.6");


// WEBPACK FOOTER //
// ./~/@dp/knb/compiled/common/version.js